import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=33be5305"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33be5305')) {
      api.createRecord('33be5305', component.options)
    } else {
      api.reload('33be5305', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=33be5305", function () {
      api.rerender('33be5305', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/sidebar.vue"
export default component.exports